export default function TestimonialSection() {
  return (
    <section className="py-16 md:py-24 px-6 md:px-12 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <span className="font-heading text-2xl md:text-3xl italic text-foreground-600">
            (What Sellers Say)
          </span>
        </div>

        <div className="bg-background-50 rounded-2xl p-8 md:p-10">
          <div className="flex items-center gap-1.5 mb-6">
            <span className="inline-flex items-center gap-1.5 px-3 py-1 bg-foreground-950 text-accent-400 rounded-full text-xs font-semibold">
              <i className="ri-star-fill text-xs w-3 h-3 flex items-center justify-center"></i>
              4.9/5
            </span>
            <span className="text-xs text-foreground-500">from verified sellers</span>
          </div>

          <blockquote className="font-heading text-xl md:text-2xl italic text-foreground-900 leading-relaxed">
            &ldquo;OOPBuy spreadsheet cut my research time by 70%. The category filters are exactly what I needed for my dropshipping store. Instead of jumping between supplier tabs, everything is organized in one structured view.&rdquo;
          </blockquote>

          <div className="flex items-center gap-4 mt-8">
            <div className="w-12 h-12 rounded-full bg-background-200 overflow-hidden flex-shrink-0">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20woman%20with%20a%20confident%20warm%20genuine%20smile%2C%20natural%20outdoor%20lighting%20with%20soft%20golden%20hour%20glow%2C%20blurred%20green%20garden%20background%2C%20authentic%20contemporary%20portrait%20photography%2C%20friendly%20approachable%20expression%2C%20crisp%20sharp%20detail%2C%20warm%20inviting%20atmosphere&width=120&height=120&seq=avatar-sarah-v2-01&orientation=squarish"
                alt="Sarah Chen"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
            <div>
              <p className="font-semibold text-foreground-950 text-sm md:text-base">Sarah Chen</p>
              <p className="text-xs md:text-sm text-foreground-500">Store Owner, KA Imports</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}